export default {
    title: 'Loyalty Program',
    title_faqs: 'FAQs For Loyalty Program',
    history_reward: {
        title: 'History Reward',
        total_active: 'Total Active',
        total_spent: 'Total Spent',
        total_expired: 'Total Expired',
        total_cashback: 'Total Cashback',
        info: 'History reward current period from {startDate} to {endDate}',
    },
    benefits: {
        entry_into_loyalty_program: {
            title: 'Entry into Loyalty Program',
            content:
                'Start your journey towards exclusive rewards as you enter the program.',
        },
        purchasing_power: {
            title: 'Purchasing Power',
            content:
                'Purchase a variety of hosting services available at 1Byte.',
        },
        customer_support: {
            title: 'Customer Support',
            content: 'Dedicated support ensures a smooth experience.',
        },
        cashback_rewards: 'Cashback Rewards',
        cashback_reward_content: 'Earn {cashback} on spending.',
        higher_cashback: 'Higher Cashback Rewards',
        highest_cashback: 'Highest Cashback Rewards',
        exclusive_discounts: {
            title: 'Exclusive Discounts',
            special_content: 'Access special discounts on services.',
            premium_content: 'Access premium discounts on services.',
        },
        cashback: 'a {amount}% cashback',
    },
    level_up: {
        title: 'Level Up',
        wordpress_hosting: {
            title: 'WP Hosting',
            description:
                'Fast WordPress hosting with specialized support and features.',
        },
        cloud_hosting: {
            title: 'Cloud Hosting',
            description:
                'Scalable, reliable hosting in the cloud for flexibility.',
        },
        shared_hosting: {
            title: 'Shared Hosting',
            description:
                'Budget-friendly hosting with shared resources for small websites.',
        },
        domain: {
            title: 'Domain',
            description: 'Unique web address for branding and online identity.',
        },
        cloud_server: {
            title: 'Cloud Server',
            description:
                'Scalable virtual servers in the cloud for business performance.',
        },
        sms_service: {
            title: 'Use SMS Service',
            description:
                'Text messaging for marketing, notifications, and customer outreach.',
        },
        aws: {
            title: 'AWS',
            description:
                'Leading AWS partner in Cambodia for trusted cloud solutions.',
        },
        ssl: {
            title: 'SSL Certificates',
            description: 'Secure your site, your way.',
        },
    },
    history_rank_title: 'Up Level History',
    spent: 'Spent',
    amount: 'Amount',
    issue_date: 'Issue Date',
    exp_date: 'Exp Date',
    current_badge: {
        next_period: 'Rankings will be updated again after {endDate}',
        see_history: 'See History',
        title: 'Current Badge',
        maintain_rank: 'You will maintain this ranking for the next period',
        maintain_rank_in_progress:
            'Spend an additional {amount} to maintain this ranking for the next period',
    },
};
